import { useNationality } from "@faire/retailer-visitor-shared/hooks/retailer/useNationality";
import { useQuery as useFetchIncomeRanges } from "@faire/web-api--source/api/user/income-ranges/get-hooks";
import keyBy from "lodash/keyBy";
import omit from "lodash/omit";
import { useCallback, useMemo } from "react";
export var useIncomeRanges = function(formCountry) {
    var retailerCountry = useNationality().retailerCountry;
    var country = useMemo(function() {
        return formCountry !== null && formCountry !== void 0 ? formCountry : retailerCountry;
    }, [
        formCountry,
        retailerCountry
    ]);
    var _useFetchIncomeRanges = useFetchIncomeRanges({
        country: country
    }), incomeRangesData = _useFetchIncomeRanges.data, isLoadingIncomeRanges = _useFetchIncomeRanges.isLoading;
    var incomeRanges = useMemo(function() {
        var _incomeRangesData_income_money_ranges;
        return (_incomeRangesData_income_money_ranges = incomeRangesData === null || incomeRangesData === void 0 ? void 0 : incomeRangesData.income_money_ranges) !== null && _incomeRangesData_income_money_ranges !== void 0 ? _incomeRangesData_income_money_ranges : [];
    }, [
        incomeRangesData
    ]);
    var incomeRangesOptions = useMemo(function() {
        return incomeRanges.map(function(incomeRange) {
            var _incomeRange_display_text, _incomeRange_display_text1;
            return {
                label: (_incomeRange_display_text = incomeRange.display_text) !== null && _incomeRange_display_text !== void 0 ? _incomeRange_display_text : "",
                value: (_incomeRange_display_text1 = incomeRange.display_text) !== null && _incomeRange_display_text1 !== void 0 ? _incomeRange_display_text1 : "",
                key: incomeRange.annual_sales_range_option
            };
        });
    }, [
        incomeRanges
    ]);
    var incomeRangeByDisplayText = useCallback(function(incomeRangeToFind) {
        return incomeRanges.find(function(incomeRange) {
            var _incomeRangeToFind_max_amount, _incomeRange_max_amount, _incomeRangeToFind_min_amount, _incomeRange_min_amount;
            if (((_incomeRangeToFind_max_amount = incomeRangeToFind.max_amount) === null || _incomeRangeToFind_max_amount === void 0 ? void 0 : _incomeRangeToFind_max_amount.amount_cents) === ((_incomeRange_max_amount = incomeRange.max_amount) === null || _incomeRange_max_amount === void 0 ? void 0 : _incomeRange_max_amount.amount_cents) && ((_incomeRangeToFind_min_amount = incomeRangeToFind.min_amount) === null || _incomeRangeToFind_min_amount === void 0 ? void 0 : _incomeRangeToFind_min_amount.amount_cents) === ((_incomeRange_min_amount = incomeRange.min_amount) === null || _incomeRange_min_amount === void 0 ? void 0 : _incomeRange_min_amount.amount_cents)) {
                return true;
            }
            return false;
        });
    }, [
        incomeRanges
    ]);
    var incomeRangesByDisplayText = useMemo(function() {
        return keyBy(incomeRanges, "display_text");
    }, [
        incomeRanges
    ]);
    var incomeRangeForKey = useCallback(function(displayText) {
        return omit(incomeRangesByDisplayText[displayText], "display_text");
    }, [
        incomeRangesByDisplayText
    ]);
    return {
        isLoadingIncomeRanges: isLoadingIncomeRanges,
        incomeRangesOptions: incomeRangesOptions,
        incomeRangeForKey: incomeRangeForKey,
        incomeRangeByDisplayText: incomeRangeByDisplayText,
        incomeMoneyRanges: incomeRanges
    };
};
